import React, { useEffect, useState } from "react";
import axios from "axios";
import shared from "../styles/shared.module.css";
import styles from "../styles/AdminEmpresas.module.css";

type Empresa = {
  id: number;
  nome: string;
  email: string;
  telefone: string;
  cidade: string;
  pais: string;
  comissao?: number;
};

const AdminComissaoEmpresas = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [abaAtiva, setAbaAtiva] = useState<"todas" | "com" | "sem">("todas");
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const [novaComissao, setNovaComissao] = useState<number | "">("");

  const carregarEmpresas = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/admins/empresas`, { headers });
      setEmpresas(res.data);
    } catch (error) {
      console.error("Erro ao carregar empresas:", error);
    }
  };

  useEffect(() => {
    carregarEmpresas();
  }, []);

  const salvarComissao = async (id: number) => {
    if (novaComissao === "" || novaComissao < 0 || novaComissao > 100) {
      alert("A comissão deve estar entre 0 e 100");
      return;
    }

    try {
      await axios.put(
        `${BASE_URL}/admins/empresas/${id}/comissao`,
        novaComissao,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("Comissão atualizada");
      setExpandedId(null);
      carregarEmpresas();
    } catch (error) {
      console.error("Erro ao atualizar comissão:", error);
    }
  };

  const removerComissao = async (id: number) => {
    try {
      await axios.put(
        `${BASE_URL}/admins/empresas/${id}/comissao`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("Comissão removida");
      setExpandedId(null);
      carregarEmpresas();
    } catch (error) {
      console.error("Erro ao remover comissão:", error);
    }
  };

  const toggleExpand = (id: number) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  const renderEmpresaCard = (empresa: Empresa) => {
    const isExpanded = expandedId === empresa.id;

    return (
      <div
        key={empresa.id}
        className={`${styles.cardEmpresa} ${isExpanded ? styles.expanded : styles.collapsed}`}
      >
        <div className={styles.summary} onClick={() => toggleExpand(empresa.id)}>
          <div className={styles.summaryInfo}>
            <strong className={styles.nomeEmpresa}>{empresa.nome}</strong>
            <span className={styles.status}>
              {empresa.comissao != null ? `💰 ${empresa.comissao}%` : "— Sem comissão"}
            </span>
          </div>
          <button className={styles.toggleBtn}>
            {isExpanded ? "▲" : "▼"}
          </button>
        </div>

        <div
          className={`${styles.detailsWrapper} ${isExpanded ? styles.detailsOpen : styles.detailsClosed}`}
        >
          {isExpanded && (
            <div className={styles.details}>
              <p><strong>Email:</strong> {empresa.email}</p>
              <p><strong>Telefone:</strong> {empresa.telefone}</p>
              <p><strong>Cidade:</strong> {empresa.cidade}</p>
              <p><strong>País:</strong> {empresa.pais}</p>

              <div style={{ marginTop: "1rem" }}>
                <label><strong>Comissão (%):</strong></label>
                <input
                  type="number"
                  min={0}
                  max={100}
                  value={novaComissao}
                  onChange={(e) =>
                    setNovaComissao(e.target.value === "" ? "" : Number(e.target.value))
                  }
                  style={{ marginLeft: "10px", width: "80px" }}
                />
              </div>

              <div className={styles.actions}>
                <button
                  className={styles.aprovarButton}
                  onClick={() => salvarComissao(empresa.id)}
                >
                  Salvar Comissão
                </button>
                <button
                  className={styles.rejeitarButton}
                  onClick={() => removerComissao(empresa.id)}
                >
                  Remover Comissão
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const listaFiltrada = empresas.filter((e) => {
    if (abaAtiva === "com") return e.comissao != null;
    if (abaAtiva === "sem") return e.comissao == null;
    return true;
  });

  return (
    <div className={shared.container}>
      <h1>Gerenciar Comissão das Empresas</h1>

      <div className={styles.tabs}>
        <button
          className={`${styles.tabButton} ${abaAtiva === "todas" ? styles.tabActive : ""}`}
          onClick={() => setAbaAtiva("todas")}
        >
          Todas
        </button>
        <button
          className={`${styles.tabButton} ${abaAtiva === "com" ? styles.tabActive : ""}`}
          onClick={() => setAbaAtiva("com")}
        >
          Com comissão
        </button>
        <button
          className={`${styles.tabButton} ${abaAtiva === "sem" ? styles.tabActive : ""}`}
          onClick={() => setAbaAtiva("sem")}
        >
          Sem comissão
        </button>
      </div>

      {listaFiltrada.length === 0 ? (
        <p>Nenhuma empresa encontrada.</p>
      ) : (
        listaFiltrada.map((empresa) => renderEmpresaCard(empresa))
      )}
    </div>
  );
};

export default AdminComissaoEmpresas;
